'use client';

import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import { ComponentBlocksMetricHighlight } from '@/types';

export function MetricHighlightBlock({ block }: { block: ComponentBlocksMetricHighlight }) {
  const metrics = (block?.MetricHighlightInfo ?? []).filter(Boolean);

  if (metrics.length === 0) return null;

  return (
    <CustomBackground
      backgroundOptions={(block?.MetricHighlightBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={
        (block?.MetricHighlightDisplayOptions ?? {
          PaddingTop: 'md',
          PaddingBottom: 'md',
          PaddingInline: 'md',
        }) as StrapiDisplayOptions
      }
      boxProps={{ 'data-component': 'MetricHighlightBlock' } as any}
    >
      {/* Heading */}
      {block.MetricHighlightTitle && (
        <Typography
          variant="h4"
          fontWeight={900}
          align="center"
          sx={{ mb: 4, textTransform: 'uppercase' }}
        >
          {block.MetricHighlightTitle}
        </Typography>
      )}

      {/* Metric Cards */}
      <Grid container spacing={4} justifyContent="center">
        {metrics.map((metric) => (
          <Grid item xs={12} sm={4} key={metric?.id}>
            <Box textAlign="center">
              <Typography variant="h3" component="div" fontWeight={900} sx={{ mb: 1 }}>
                {metric?.MetricInfo}
              </Typography>
              <Typography variant="subtitle1" fontWeight={500}>
                {metric?.MetricDescription}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </CustomBackground>
  );
}
